import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';

/**  Endpoint to fetch shipping timeline.  */
export const fetchTimelineApi = createApi({
  reducerPath: 'fetchTimelineApi',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    getTimeline: builder.mutation({
      query: ({ data }) => ({
        url: `api/v4/shipping-timeline`,
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useGetTimelineMutation } = fetchTimelineApi;
